import {
  EventOutlined,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  NavigateBefore,
  NavigateNext,
  SkipPreviousOutlined,
} from '@mui/icons-material';
import { Button, IconButton, Tooltip } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect, useRef, useState } from 'react';
import { useTherapyPlanning } from './therapyPlanningProvider';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

type Props = {};
const ButtonStyle = {
  width: '32px',
  height: '32px',
  padding: '10px',
  borderRadius: '8px',
  border: '1px solid #F1F1F1',
  background: '#FFFFFF',
};

const IconStyle = {
  color: '#6366F1',
  fontSize: '14px',
};

const BasicDateCalendar = ({ handleChangeDate, value, futureDisable = false }: any) => {
  const jsDate = moment(value, 'DD-MM-YYYY').toDate();
  return (
    <DateCalendar
      sx={{
        boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
        position: 'absolute',
        background: '#fff',
        zIndex: 10,
        marginTop: '20px',
        width: '280px',
      }}
      defaultValue={jsDate}
      onChange={handleChangeDate}
      disableFuture={futureDisable}
    />
  );
};

const TherapyPlaningNavigation = (props: Props) => {
  const { weekStartDate, setWeekStartDate, setWeekEndDate, weekEndDate } = useTherapyPlanning();

  const [openCalender, setOpenCalender] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const calenderRef = useRef<HTMLDivElement | null>(null);

  const selectedPatient = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);

  const goToNextWeek = () => {
    setWeekStartDate(weekStartDate.clone().add(9, 'days'));
    setWeekEndDate(weekEndDate.clone().add(9, 'days'));
  };

  const goToPreviousWeek = () => {
    setWeekStartDate(weekStartDate.clone().subtract(9, 'days'));
    setWeekEndDate(weekEndDate.clone().subtract(9, 'days'));
  };

  const goToPreviousDay = () => {
    setWeekStartDate(weekStartDate.clone().subtract(1, 'days'));
    setWeekEndDate(weekEndDate.clone().subtract(1, 'days'));
  };
  const goToNextDate = () => {
    setWeekStartDate(weekStartDate.clone().add(1, 'days'));
    setWeekEndDate(weekEndDate.clone().add(1, 'days'));
  };

  const navigateToday = () => {
    setWeekStartDate(moment().clone().startOf('week'));
    setWeekEndDate(moment().clone().endOf('week'));
  };

  const navigateToEoc = () => {
    setWeekStartDate(
      moment(selectedPatient?.eocStartDate)
        .clone()
        .startOf('week')
    );
    setWeekEndDate(
      moment(selectedPatient?.eocStartDate)
        .clone()
        .endOf('week')
    );
  };
  const handleClickCalender = () => {
    setOpenCalender((prev: any) => !prev);
  };
  const handleChangeDate = (e: any) => {
    const newDate = moment(e);
    setSelectedDate(newDate.toDate());
    setWeekStartDate(newDate);
    setWeekEndDate(newDate.clone().add(9, 'days'));
    setOpenCalender(false);
  };

  useEffect(() => {
    if (openCalender) {
      const handleClickOutside = (event: any) => {
        if (calenderRef.current && !calenderRef.current.contains(event.target)) {
          handleClickCalender();
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openCalender]);

  const today = moment();

  return (
    <Stack
      gap=".5rem"
      alignItems="center"
      flexDirection="row"
      ref={calenderRef}
    >
      <Tooltip
        placement="top-start"
        title="Start of EoC"
      >
        <IconButton
          onClick={navigateToEoc}
          sx={ButtonStyle}
        >
          <SkipPreviousOutlined sx={IconStyle} />
        </IconButton>
      </Tooltip>
      <Tooltip
        placement="top-start"
        title="Previous"
      >
        <IconButton
          onClick={goToPreviousWeek}
          sx={ButtonStyle}
        >
          <KeyboardDoubleArrowLeft sx={IconStyle} />
        </IconButton>
      </Tooltip>
      <Tooltip
        placement="top-start"
        title="Previous Day"
      >
        <IconButton
          onClick={goToPreviousDay}
          sx={ButtonStyle}
        >
          <NavigateBefore sx={IconStyle} />
        </IconButton>
      </Tooltip>
      <Button
        variant="outlined"
        size="small"
        onClick={navigateToday}
        disabled={
          today.isAfter(weekStartDate) && today.isBefore(weekEndDate.clone().add(2, 'days'))
        }
      >
        Today
      </Button>
      <Stack>
        {openCalender && (
          <BasicDateCalendar
            value={selectedDate}
            handleChangeDate={handleChangeDate}
          />
        )}
      </Stack>
      <Tooltip
        placement="top-start"
        title="Next Day"
      >
        <IconButton
          onClick={goToNextDate}
          sx={ButtonStyle}
        >
          <NavigateNext sx={IconStyle} />
        </IconButton>
      </Tooltip>
      <Tooltip
        placement="top-start"
        title="Next"
      >
        <IconButton
          onClick={goToNextWeek}
          sx={ButtonStyle}
        >
          <KeyboardDoubleArrowRight sx={IconStyle} />
        </IconButton>
      </Tooltip>
      <Tooltip
        placement="top-start"
        title="Select a date"
      >
        <Stack>
          <IconButton
            onClick={handleClickCalender}
            sx={ButtonStyle}
          >
            <EventOutlined sx={IconStyle} />
          </IconButton>
        </Stack>
      </Tooltip>
    </Stack>
  );
};

export default TherapyPlaningNavigation;
